<template>
  <div :class="isMobile === 'mobile' ? 'mobile-login-panel' : 'login-panel'">
    <div class="change-panel">
      <p @click="changePanel = true" :class="changePanel ? 'active' : ''">
        <span>快捷登录</span>
        <span class="item-line" v-show="changePanel"></span>
      </p>
      <p @click="changePanel = false" :class="!changePanel ? 'active' : ''">
        <span>密码登录</span>
        <span class="item-line" v-show="!changePanel"></span>
      </p>
    </div>
    <div class="login-contain">
      <el-form v-if="changePanel" ref="form" :model="formData" :rules="rulePhone">
        <el-form-item prop="phone">
          <el-input class="input-style" v-model="formData.phone" placeholder="输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input class="input-style special-input-style" v-model="formData.code" placeholder="输入验证码">
            <span class="span-style" slot="suffix" @click="getCheckCode" v-if="timeSetting <= 0">获取验证码</span>
            <span class="span-style" style="cursor:none" slot="suffix" v-else>{{timeSetting}}秒</span>
          </el-input>
        </el-form-item>
      </el-form>
      <el-form v-else ref="form" :model="formData" :rules="rulePass">
        <el-form-item prop="phone">
          <el-input class="input-style" v-model="formData.phone" placeholder="输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="pwd">
          <el-input class="input-style" v-model="formData.pwd" show-password placeholder="输入密码"></el-input>
        </el-form-item>
      </el-form>
      <el-button class="login-btn" @click="loginAccount('form')">登录</el-button>
      <div class="no-account" v-if="changePanel">
        没有账号？<span @click="emitParentStatus('register')">去注册</span>
      </div>
      <div class="no-account" v-else>
        <span style="color: #999999" @click="emitParentStatus('forget')">忘记密码？</span>
      </div>
      <div class="wechat-login">
        <span>其他方式登录</span>
        <i @click="emitParentStatus('wechat')"></i>
      </div>
    </div>
  </div>
</template>

<script>
  import { loginApi } from '../../api'
  import { setCookie } from "../../assets/js/utils";

  export default {
    name: "loginPanel",
    props: {
      isMobile: {
        type: String,
        default: ''
      }
    },
    data() {
      let checkPhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入手机号码'))
        } else {
          let pattern = /^[1]([3-9])[0-9]{9}$/
          if (pattern.test(value)) {
            callback()
          } else {
            callback(new Error('请输入正确的手机号码'))
          }
        }
      }
      return {
        changePanel: true,
        formData: {},
        timeSetting: 0,
        rulePhone: {
          phone: [{ required: true, validator: checkPhone, trigger: 'blur' }],
          code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
        },
        rulePass: {
          phone: [{ required: true, validator: checkPhone, trigger: 'blur' }],
          pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }]
        },
        isSendCode: false
      }
    },
    methods: {
      getCheckCode() {
        if (/^[1]([3-9])[0-9]{9}$/.test(this.formData.phone)) {
          if (this.isSendCode) return
          this.isSendCode = true
          loginApi.loginCodeFunc(this.formData.phone).then(res => {
            this.isSendCode = false
            if (res.code === 200) {
              this.$message.success('发送成功')
              this.timeSetting = 60
              this.timeSettingFunc()
            } else {
              this.$message.error(res.msg)
            }
          }).catch(err => {
            this.isSendCode = false
          })
        } else {
          this.$message.error('请填写手机号码')
        }
      },
      timeSettingFunc() {
        let temp = setInterval(() => {
          if (this.timeSetting <= 1) {
            clearInterval(temp)
          }
          --this.timeSetting
        }, 1000)
      },
      loginAccount(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.changePanel) {
              this.loginCheck(2)
            } else {
              this.loginCheck(1)
            }
          } else {
            this.$message.error('请填写完整')
            return false
          }
        })
      },
      // 登录接口
      loginCheck(type) {
        loginApi.loginFunc({
          phone: this.formData.phone,
          code: this.formData.code,
          pwd: this.formData.pwd,
          type: type
        }).then(res => {
          if (res.code === 200) {
            this.$message.success('登录成功')
            this.getUserInfo()
            if (res.data.channelType && res.data.channelName) {
              let obj = { id: res.data.channelType, channelName: res.data.channelName };
              this.$store.commit('industry/SET_CHANNEL', obj);
            }
          } else {
            this.$message.error(res.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      },
      getUserInfo() {
        this.$store.dispatch('user/getUserInfo').then(res => {
          this.$emit('successFunc')
        }).catch(err => {
          console.log(err)
        })
      },
      emitParentStatus(val) {
        if (this.isWeiXin() && val === 'wechat') {
          if (this.isMobile === 'mobile') {
            let href = window.location;
            //不需要跳转回来的话,服务端默认跳转到/industry
            href = "";
            let redirect_uri = encodeURIComponent('http://enplus.org.cn/high/account/wxLogin?returnUrl=' + href)
            window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf7b9d9ba23b39871&redirect_uri=' + redirect_uri + '&response_type=code&scope=snsapi_userinfo&state=#wechat_redirect';
            return;
          }
        }
        this.$emit('changePanel', val)
      },
      isWeiXin() {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.match(/MicroMessenger/i) == "micromessenger") {
          return true;
        } else {
          return false;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-panel {
    .change-panel {
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: 24px;
      color: #999999;
      padding: 0 p2r(60px);

      p {
        position: relative;
        cursor: pointer;
      }

      .item-line {
        display: inline-block;
        position: absolute;
        width: p2r(48px);
        height: 2px;
        background-color: #333333;
        left: 50%;
        margin-left: -24px;
        bottom: -10px;
      }
    }

    .login-contain {
      padding: 30px 60px;

      .input-style {
        > > > .el-input__inner {
          height: p2r(56px);
          line-height: p2r(56px);
          border-radius: 0;
        }

        &:nth-of-type(1) {
          /*margin-bottom: p2r(30px);*/
        }
      }

      .special-input-style {
        > > > .el-input__inner {
          padding-right: p2r(110px);
        }
      }

      .span-style {
        line-height: 56px;
        font-size: 16px;
        color: $bloodRed;
        margin-right: p2r(20px);
        cursor: pointer;
      }

      .login-btn {
        margin-top: p2r(40px);
        margin-bottom: p2r(20px);
        background: $bloodRed;
        color: #ffffff;
        width: 100%;
        height: p2r(60px);
        font-size: 18px;
        border-radius: 0;
      }

      .no-account {
        font-size: 16px;
        color: #999999;
        margin-top: p2r(20px);
        margin-bottom: p2r(40px);

        span {
          color: $bloodRed;
          cursor: pointer;
        }
      }

      .wechat-login {
        color: #999999;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        span {
          height: p2r(16px);
          font-size: p2r(16px);
          margin-bottom: p2r(20px);
        }

        i {
          display: inline-block;
          width: p2r(50px);
          height: p2r(50px);
          background: url("../../assets/img/login/login_wechat.png") no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
        }
      }
    }
  }

  .mobile-login-panel {
    .change-panel {
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: p2r(14px);
      color: #999999;
      padding: 0 p2r(70px);

      p {
        position: relative;
        cursor: pointer;
      }

      .item-line {
        display: inline-block;
        position: absolute;
        width: p2r(24px);
        height: p2r(1px);
        background-color: #333333;
        left: 50%;
        margin-left: p2r(-12px);
        bottom: p2r(-5px);
      }
    }

    .login-contain {
      padding: p2r(20px) p2r(45px);

      > > > .el-form-item {
        margin-bottom: p2r(20px);
      }

      .input-style {
        > > > .el-input__inner {
          height: p2r(36px);
          line-height: p2r(36px);
          border-radius: 0;
        }
      }

      .special-input-style {
        > > > .el-input__inner {
          padding-right: p2r(75px);
        }
      }

      .span-style {
        line-height: p2r(36px);
        font-size: p2r(12px);
        color: $bloodRed;
        margin-right: p2r(10px);
        cursor: pointer;
      }

      .login-btn {
        margin-bottom: p2r(15px);
        background: $bloodRed;
        color: #ffffff;
        width: 100%;
        height: p2r(36px);
        font-size: p2r(14px);
        border-radius: 0;
      }

      .no-account {
        font-size: p2r(12px);
        color: #999999;
        margin-bottom: p2r(30px);

        span {
          color: $bloodRed;
          cursor: pointer;
        }
      }

      .wechat-login {
        color: #999999;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        span {
          height: p2r(12px);
          font-size: p2r(12px);
          margin-bottom: p2r(10px);
        }

        i {
          display: inline-block;
          width: p2r(30px);
          height: p2r(30px);
          background: url("../../assets/img/login/login_wechat.png") no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
        }
      }
    }
  }

  .active {
    color: #333333;
  }
</style>



// WEBPACK FOOTER //
// src/components/loginPanel/loginPanel.vue